import React, { useEffect, useState } from 'react';
import axios from 'axios'
import {getCookie} from '../../common/utils/auth'
import { message, Spin, Form, Input, Button, Select } from 'antd';
import { config } from "enviroment.js"
import "antd/dist/antd.css";
import './Admin.scss';
import AdminPageHeader from './AdminPageHeader'


const UserCreateView = (props) => {
  const [loading, setLoading] = useState({ status: true, type: 'page' })
  const [error, setError] = useState({ status: false })
  const [stores, setStores] = useState([])
  const [btnLoading, setBtnLoading] = useState(false)
  const [form] = Form.useForm()

  useEffect(() => {
    if (form) {
      axios.get(config.raUrl + `/admin/users/stores`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookie('token')}`
        }
      })
        .then((res) => {
          setStores(res.data)
          form.setFieldsValue(res.data)
          setLoading({ status: false })
        }).catch((err) => {
          console.log("error caught: ", err.response)
          let errorMessage = {
            status: true,
            text: 'Ooops!',
            sub: 'Something went wrong.'
          }
          if (err.response.status === 401) {
            errorMessage.text = 'Unauthorized'
            errorMessage.sub = 'You are not authorized to view this page.'
          }
          setError(errorMessage)
          setLoading({ status: false })
        })
    }
  }, [form])
  
  const handleSubmit = (values) => {
    setBtnLoading(true)
    values.stores = JSON.stringify(values.stores)
    delete values.confirm_password
    axios.post(config.raUrl + `/admin/users`, values, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getCookie('token')}`
      }
    })
      .then((res) => {
        props.history.replace({ pathname: '/admin/users' })
        message.success('User created!');
      }).catch((err) => {
        console.log("error caught: ", err.response)
        message.error(err.response.data.msg);
      }).finally(
        setBtnLoading(false)
      )
  }

  return (
    <Spin spinning={loading.status} size="large" className={loading.status && loading.type}>
      {error.status
        ? (
          <>
          <div className="error-container">
            <div className="error-text">{error.text}</div>
            <div className="error-sub">{error.sub}</div>
          </div>
          </>
        ) : (
          <>
          <AdminPageHeader
            onBack={() => { window.location.href = '/admin/users/' }}
            title="Add User"
          />
          <div className="userFormContainer">
            <Form
              layout="vertical"
              form={form}
              onFinish={handleSubmit}
            >
              <Form.Item label="First Name" name="firstName" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item label="Last Name" name="lastName" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item label="Email" name="email" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item name="role" label="Role" rules={[{ required: true }]}>
                <Select >
                  <Select.Option value="staff">Staff</Select.Option>
                  <Select.Option value="admin">Admin</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item name="stores" label="Stores" rules={[{ required: true }]}>
                <Select
                  mode="multiple"
                >
                  <Select.Option value="all">All Stores</Select.Option>
                  {stores.map(store => (
                    <Select.Option key={store.store_id} value={store.store_id}>{store.title}</Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, message: 'Please input your password!' }]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item
                label="Confirm Password"
                name="confirm_password"
                rules={[
                  { required: true, message: 'Please confirm your password!' },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject('The two passwords that you entered do not match!');
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item >
                <Button className="user-form-btn" type="primary" htmlType="submit" loading={btnLoading}>Submit</Button>
              </Form.Item>
            </Form>
          </div>
          </>
        )
      }
    </Spin>
  )
}
export default UserCreateView;
